<template>
    <div class="product_shelves_add_container " v-loading="loading">
        <div class="product_shelves_add_return">
            <span class="return" @click="handleClickReturn"><i class="el-icon-arrow-left"></i>返回</span>
            <span class="line"></span>
            <span class="title">新增产品</span>
            <span class="line"></span>
            <span class="grouping_name">当前分组：{{category_name}}</span>
            <span class="switch_btn" @click="groupingSwitchVisible = true"><i class="iconfont icon-qiehuan"></i>切换</span>
        </div>
        <div class="product_shelves_add_wrap">
            <div class="product_shelves_add_left">
                <div class="product_shelves_add_left_top">
                    <ul>
                        <li @click="handleClickTab(item)" :class="tabActive == item.value ? 'active':''" v-for="item in tabList" v-text="item.name"></li>
                    </ul>
                </div>
                <div class="product_shelves_add_left_bottom">
                    <div v-show="tabActive == 1">
                        <div class="shelves_search_wrap">
                            <el-input size="small" v-model="keyword" placeholder="请输入想搜索的内容"  clearable  @clear="handleClickSearch" @blur="handleClickSearch" ref="search_input_ref1" @keyup.enter.native="handleEnterSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                            </el-input>
                        </div>
                        <el-table class="custom_table" :data="tableData" border ref="stock_product_table" @selection-change="handleSelectionChange" row-key="product_name" :height="tableHeight" >
                            <el-table-column align="center" type="selection"  :selectable="disableSelection" reserve-selection width="50"></el-table-column>
                            <el-table-column label="产品名称" prop="product_name"></el-table-column>
                        </el-table>
                        <div class="shelves_pagination">
                            <el-pagination background
                                           size="mini"
                                           @size-change="handleSizeChange"
                                           @current-change="handleCurrentChange"
                                           :current-page="pagination.pageNum"
                                           :page-sizes="pagination.pageSizes"
                                           :page-size="pagination.pageSize"
                                           :layout="pagination.layout"
                                           :pager-count="5"
                                           :total="pagination.total">
                            </el-pagination>
                        </div>
                    </div>

                    <div v-show="tabActive == 2">
                        <div class="shelves_search_wrap">
                            <el-input size="small" v-model="keyword" placeholder="请输入想搜索的内容"  clearable  @clear="handleClickSearch();getCloudCateList()" @blur="handleClickSearch();getCloudCateList()" ref="search_input_ref2" @keyup.enter.native="handleEnterSearch">
                                <i slot="suffix" class="el-icon-search" @click="handleClickSearch();getCloudCateList()"></i>
                            </el-input>
                        </div>
                        <div class="shelves_industry_standards">
                            <div class="shelves_industry_standards_left">
                                <div class="category">
                                    <div class="category_top" :class="{'active':groupingId == ''}" @click="handleClickGroupingItem({id:0})" >
                                        <p>全部产品</p>
                                    </div>
                                    <div class="category_bottom" :class="{'noActiveTree':groupingId == ''}">
                                        <el-tree ref="cateGoryTreeRef"
                                                 :data="groupingList"
                                                 :current-node-key="groupingId"
                                                 :expand-on-click-node='false'
                                                 :props="{children: 'children',label: 'name'}"
                                                 @node-click="handleClickGroupingItem"
                                                 check-on-click-node
                                                 highlight-current
                                                 check-strictly
                                                 default-expand-all
                                                 node-key="id">
                                            <div  class="custom_tree_node" slot-scope="{ node, data }">
                                                <div  class="node_label single-line">{{node.label }}</div>
                                            </div>
                                        </el-tree>
                                    </div>
                                </div>
                            </div>
                            <div class="shelves_industry_standards_right">
                                <ul v-infinite-scroll="onLoadList">
                                    <li :class="item.is_down_up ? 'is_retract' : ''" v-for="item in basicTableData">
                                        <div class="industry_standards_top">
                                            <div class="check_box">
                                                <el-checkbox @change="handleChangeStandardItem(item)" :disabled="item.skus && item.skus.filter(find => find.is_online).length == item.skus.length ? true : false" v-model="item.checked"></el-checkbox>
                                            </div>
                                            <div class="industry_standards_name">
                                                <span class="name ellipsis">{{item.name}}</span>
                                                <span class="brand_name ellipsis" v-text="item.brand && item.brand.name ? item.brand.name : ''"></span>
                                                <span class="handle_icon_wrap" @click="item.is_down_up = !item.is_down_up">
                                                    <i class="el-icon-caret-bottom"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="industry_standards_bottom" v-if="item.is_down_up">
                                           <div class="list" v-for="list in item.skus">
                                               <div class="check_box">
                                                   <el-checkbox @change="handleChangeStandardList(item,list)" :disabled="list.is_online" v-model="list.checked"></el-checkbox>
                                               </div>
                                               <div class="industry_standards_name">
                                                   {{list.name}}
                                               </div>
                                           </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div v-show="tabActive == 3">
                        <div class="custom_product_add">
                            <el-form size="small" ref="customProductForm" label-position="top" :model="customProductForm"  :rules="customProductFormRules">
                                <el-form-item label="产品名称" prop="goods_name">
                                    <el-input v-model="customProductForm.goods_name"  placeholder="请输入名称"></el-input>
                                </el-form-item>

                                <el-form-item label="产品图片" prop="image">
                                    <div class="image_outer_wrap">
                                        <ul  class="upload_image_list">
                                            <li v-for="(item,index) in customProductForm.image"
                                                :key="index"
                                                class="upload_image_item">
                                                <i @click="customProductForm.image.splice(index,1)" class="el-icon-error"></i>
                                                <el-image
                                                        :preview-src-list="customProductForm.image.map(img=>img)"
                                                        :src="item"
                                                        fit="cover">
                                                </el-image>

                                            </li>
                                            <li class="image_upload_wrap">
                                                <input accept=".png, .jpg, .jpeg"
                                                       class="upload_input"
                                                       multiple
                                                       type="file"
                                                       @change="handleClickUploadImg($event,customProductForm.image)">
                                                <i class="el-icon-plus"></i>
                                            </li>
                                        </ul>
                                        <p class="image_hint">从本地上传图片，支持多张上传、多种图片格式。</p>
                                    </div>
                                </el-form-item>

                                <el-form-item label="计量单位" prop="unit">
                                    <el-input v-model="customProductForm.unit"  placeholder="请输入计量单位" maxlength="10" show-word-limit></el-input>
                                </el-form-item>

                                <el-form-item label="是否需要出入库" prop="unit">
                                    <template v-slot:label>
                                       <div class="flex_wrap">
                                           <span>是否需要出入库</span>
                                           <div class="label_position ml_16"><el-switch  v-model="customProductForm.can_in_out_stock" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="ml_8" v-text="customProductForm.can_in_out_stock == 1 ?'是' : '否'"></span></div>
                                       </div>
                                    </template>
                                </el-form-item>

                                <el-form-item label="产品描述" prop="note">
                                    <el-input v-model="customProductForm.description" type="textarea"  placeholder="请输入产品描述" ></el-input>
                                </el-form-item>

                                <el-form-item label="成本价" prop="cost_price">
                                    <template v-slot:label>
                                        <div class="flex_wrap">
                                            <span>成本价</span>
                                            <div class="label_position"><span>（用于计算订单中的产品利润）</span></div>
                                        </div>
                                    </template>
                                    <el-input v-model="customProductForm.cost_price" @blur="handleBlurPrice('cost_price')"  placeholder="请输入" ></el-input>
                                </el-form-item>

                                <el-form-item label="是否可销售" prop="unit">
                                    <template v-slot:label>
                                        <div class="flex_wrap">
                                            <span>是否可销售</span>
                                            <div class="label_position ml_16"><el-switch  v-model="customProductForm.is_sale" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="ml_8" v-text="customProductForm.is_sale == 1 ?'是' : '否'"></span></div>
                                        </div>
                                    </template>
                                    <p class="hint">开关关闭，在下订单时该产品不允许销售</p>
                                </el-form-item>

                                <el-form-item label="销售指导价" prop="sale_price" v-if="customProductForm.is_sale == 1">
                                    <el-input v-model="customProductForm.sale_price" @blur="handleBlurPrice('sale_price')"  placeholder="请输入" ></el-input>
                                </el-form-item>

                                <el-form-item label="是否可租借" prop="unit">
                                    <template v-slot:label>
                                        <div class="flex_wrap">
                                            <span>是否可租借</span>
                                            <div class="label_position ml_16"><el-switch  v-model="customProductForm.is_lease" @change="customProductForm.lease_price = ''" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="ml_8" v-text="customProductForm.is_lease == 1 ?'是' : '否'"></span></div>
                                        </div>
                                    </template>
                                    <p class="hint">开关关闭，在下订单时该产品不允许租借</p>
                                </el-form-item>

                                <el-form-item label="租借指导价" prop="lease_price" v-if="customProductForm.is_lease == 1">
                                    <el-input v-model="customProductForm.lease_price" @blur="handleBlurPrice('lease_price')"  placeholder="请输入" ></el-input>
                                </el-form-item>
                            </el-form>
                            <div class="custom_product_add_btns">
                                <el-button type="primary" size="small" @click="handleClickSave('custom_product')">保存</el-button>
                            </div>
                        </div>
                    </div>

                    <div v-show="tabActive == 4">
                        <div class="custom_product_add">
                            <el-form size="small" ref="bundleProductForm" label-position="top" :model="customProductForm"  :rules="customProductFormRules">
                                <el-form-item label="产品名称" prop="goods_name">
                                    <el-input v-model="customProductForm.goods_name"  placeholder="请输入名称"></el-input>
                                </el-form-item>

                                <el-form-item label="产品图片" prop="image">
                                    <div class="image_outer_wrap">
                                        <ul  class="upload_image_list">
                                            <li v-for="(item,index) in customProductForm.image"
                                                :key="index"
                                                class="upload_image_item">
                                                <i @click="customProductForm.image.splice(index,1)" class="el-icon-error"></i>
                                                <el-image
                                                        :preview-src-list="customProductForm.image.map(img=>img)"
                                                        :src="item"
                                                        fit="cover">
                                                </el-image>

                                            </li>
                                            <li class="image_upload_wrap">
                                                <input accept=".png, .jpg, .jpeg"
                                                       class="upload_input"
                                                       multiple
                                                       type="file"
                                                       @change="handleClickUploadImg($event,customProductForm.image)">
                                                <i class="el-icon-plus"></i>
                                            </li>
                                        </ul>
                                        <p class="image_hint">从本地上传图片，支持多张上传、多种图片格式。</p>
                                    </div>
                                </el-form-item>

                                <el-form-item label="产品描述" prop="description">
                                    <el-input v-model="customProductForm.description" type="textarea"  placeholder="请输入产品描述" ></el-input>
                                </el-form-item>

                                <el-form-item label="是否可销售" prop="unit">
                                    <template v-slot:label>
                                        <div class="flex_wrap">
                                            <span>是否可销售</span>
                                            <div class="label_position ml_16"><el-switch  v-model="customProductForm.is_sale" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="ml_8" v-text="customProductForm.is_sale == 1 ?'是' : '否'"></span></div>
                                        </div>
                                    </template>
                                    <p class="hint">开关关闭，在下订单时该产品不允许销售</p>
                                </el-form-item>



                                <el-form-item label="是否可租借" prop="unit">
                                    <template v-slot:label>
                                        <div class="flex_wrap">
                                            <span>是否可租借</span>
                                            <div class="label_position ml_16"><el-switch  v-model="customProductForm.is_lease" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="ml_8" v-text="customProductForm.is_lease == 1 ?'是' : '否'"></span></div>
                                        </div>
                                    </template>
                                    <p class="hint">开关关闭，在下订单时该产品不允许租借</p>
                                </el-form-item>



                                <div class="custom_title">
                                    <span>配置信息</span>
                                </div>

                                <div class="combination_product">
                                    <ul>
                                        <draggable v-model="customProductForm.part">
                                            <li v-for="(item,index) in customProductForm.part" :key="index">
                                            <div class="region_name_wrap">
                                                <el-input v-model="item.part_name" size="small" maxlength="30" show-word-limit placeholder="请输入部位名称" ></el-input>
                                                <div class="custom_input_number">
                                                    <el-input-number v-model="item.num"  size="small"   :min="1"  placeholder="" ></el-input-number>
                                                </div>
                                                <span class="handle_icon_wrap" @click="customProductForm.part.splice(index,1)"><i class="iconfont icon-shanchu1"></i></span>
                                            </div>
                                            <div class="default_number_repeat">
                                                <div>默认展示：<el-switch  v-model="item.is_show" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="switch_text" v-text="item.is_show == 1 ?'是' : '否'"></span></div>
                                                <div>数量可修改：<el-switch  v-model="item.num_edit" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="switch_text" v-text="item.num_edit == 1 ?'是' : '否'"></span></div>
                                                <div>允许重复添加：<el-switch  v-model="item.is_add" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch><span class="switch_text" v-text="item.is_add == 1 ?'是' : '否'"></span></div>
                                            </div>
                                            <div class="product_item">
                                                <div class="product_item_top">
                                                  <div class="product_item_name">
                                                      <span class="ellipsis">产品名称 <span v-if="item.type == 'basic' && item.goods_list.length>0">（{{item.goods_list[0].goods_name}}）</span></span>
                                                      <el-button v-if="item.type == 'basic'" type="text" @click="handleClickChangeProduct(item,'switch')"><i class="iconfont icon-qiehuan"></i>切换产品</el-button>
                                                      <el-button v-else type="text" @click="handleClickChangeProduct(item,'add')"><i class="iconfont icon-tianjia1"></i>添加产品</el-button>
                                                  </div>
                                                  <div class="product_item_handle">
                                                      <span v-text="item.type == 'basic' ? '是否启用' : '操作'"></span>
                                                  </div>
                                                </div>
                                                <div class="product_item_bottom" v-if="item.goods_list && item.goods_list.length>0">
                                                    <div class="list" v-for="(list,index) in item.type != 'basic' ? item.goods_list : item.goods_list[0].skus" :key="index">
                                                        <div class="product_item_name">
                                                            {{list.goods_name}}
                                                        </div>
                                                        <div class="product_item_handle">
                                                            <el-switch v-if="item.type == 'basic'" v-model="list.status" active-color="#2990FF"></el-switch><span class="switch_text" v-if="item.type == 'basic'" v-text="list.status ?'是' : '否'"></span>
                                                            <span v-if="item.type != 'basic'" class="handle_icon_wrap handle_icon_danger_wrap" @click="item.goods_list.splice(index,1)"><i class="iconfont icon-shanchu1"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        </draggable>
                                    </ul>
                                    <div class="combination_product_handle"  @click="handleClickAddRegion">
                                        <span ><i class="el-icon-plus"></i>添加部位</span>
                                    </div>
                                </div>

                            </el-form>
                            <div class="custom_product_add_btns">
                                <el-button type="primary"  size="small" @click="handleClickSave('bundle_product')">保存</el-button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <div class="product_shelves_add_right">
                <div class="product_shelves_add_right_top">
                    <div class="bold_title">已选产品：{{stock_product.length + basic_product.length + custom_product.length + bundle_product.length}}个</div>
                    <div>
                        <el-switch  v-model="is_online" :active-value="1" :inactive-value="0" active-color="#2990FF"></el-switch> <span>上架</span>
                    </div>
                </div>
                <div class="product_shelves_add_right_content">
                    <div class="title" v-if="stock_product.length > 0">库存产品：</div>
                    <ul>
                        <li v-for="(item,key) in stock_product" :key="key">
                            <p class="ellipsis" v-text="item.product_name"></p>
                            <div>
                                <span class="handle_icon_wrap" @click="handleClickGoodsEdit(item,key,'stock')"><i class="iconfont icon-bianji"></i></span>
                                <span class="handle_icon_wrap handle_icon_danger_wrap" @click="handleClickDelProduct('stock',key,item)"><i class="iconfont icon-shanchu1"></i></span>
                            </div>
                        </li>
                    </ul>
                    <div class="title" v-if="basic_product.length > 0">行业标准产品：</div>
                    <ul>
                        <li v-for="(item,key) in basic_product" :key="key">
                            <p class="ellipsis" >
                                <span class="ellipsis" v-text="item.name"></span>
                                <span class="brand_name" v-text="item.brand && item.brand.name ? item.brand.name : ''"></span>
                                <span>(含{{item.skus.length}}种产品)</span>
                            </p>
                            <div>
                                <span class="handle_icon_wrap" @click="handleClickGoodsEdit(item,key,'basic')"><i class="iconfont icon-bianji"></i></span>
                                <span class="handle_icon_wrap handle_icon_danger_wrap" @click="handleClickDelProduct('basic',key,item)" ><i class="iconfont icon-shanchu1"></i></span>
                            </div>
                        </li>
                    </ul>
                    <div class="title" v-if="custom_product.length > 0">自定义产品：</div>
                    <ul>
                        <li v-for="(item,key) in custom_product" :key="key">
                            <p class="ellipsis" v-text="item.goods_name"></p>
                            <div>
                                <span class="handle_icon_wrap" @click="handleClickGoodsEdit(item,key,'custom')"><i class="iconfont icon-bianji"></i></span>
                                <span class="handle_icon_wrap handle_icon_danger_wrap" @click="custom_product.splice(key,1)"><i class="iconfont icon-shanchu1"></i></span>
                            </div>
                        </li>
                    </ul>
                    <div class="title" v-if="bundle_product.length > 0">组合产品：</div>
                    <ul>
                        <li v-for="(item,key) in bundle_product" :key="key">
                            <p class="ellipsis" v-text="item.goods_name"></p>
                            <div>
                                <span class="handle_icon_wrap" @click="handleClickGoodsEdit(item,key,'bundle')"><i class="iconfont icon-bianji"></i></span>
                                <span class="handle_icon_wrap handle_icon_danger_wrap" @click="bundle_product.splice(key,1)"><i class="iconfont icon-shanchu1"></i></span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="product_shelves_add_right_bottom">
                    <el-button type="primary" :disabled="btnDisabled" size="small" @click="handleClickConfirm">提交已选</el-button>
                </div>
            </div>

        </div>
        <RegionAdd :regionAddVisible.sync="regionAddVisible" v-if="regionAddVisible" :selectedData="selectedData"  @success="regionAddSuccess"/>
        <GroupingSwitch :groupingSwitchVisible.sync="groupingSwitchVisible" v-if="groupingSwitchVisible" :groupingId="category_id" @success="groupingSwitchSuccess"/>

        <ordinaryEdit :ordinaryEditVisible.sync="ordinaryEditVisible" v-if="ordinaryEditVisible" :goodsType="goodsType" :goodsInfo="goodsInfo"  @success="goodsEditSuccess"/>
        <standardEdit :standardEditVisible.sync="standardEditVisible" v-if="standardEditVisible" :goodsType="goodsType" :goodsInfo="goodsInfo"  @success="goodsEditSuccess"/>
        <combinationEdit :combinationEditVisible.sync="combinationEditVisible" v-if="combinationEditVisible" :goodsType="goodsType" :goodsInfo="goodsInfo"  @success="goodsEditSuccess"/>
    </div>
</template>

<script>
import {GoodsStockProductList,cloudCateList,GoodsUpProductList,GoodsPutProductOnline} from "@/api"
import {pagination} from "@/mixins";
import {getTableHeight,formatFileSize} from "@/utils"
import {uploadImg} from '@/utils/uploadOss'
import RegionAdd from "./component/region_add"
import GroupingSwitch from "./component/grouping_switch"

import ordinaryEdit from "./component/ordinary_edit.vue";
import standardEdit from "./component/standard_edit.vue";
import combinationEdit from "./component/combination_edit.vue";
import draggable from 'vuedraggable'
import {removeTag} from "@/utils"
export default {
    name: "ProductShelvesAdd",
    components: {
        RegionAdd,
        GroupingSwitch,

        ordinaryEdit,
        standardEdit,
        combinationEdit,
        draggable
    },
    data() {
        return {
            btnDisabled:false,
            loading:false,
            tabActive:1,
            tabList:[
                {value:1,name:'库存产品'},
                {value:2,name:'行业标准产品'},
                {value:3,name:'自定产品'},
                {value:4,name:'组合产品'},
            ],

            tableData:[],
            basicTableData:[],
            keyword:'',
            tableHeight:'',
            groupingList:[],
            groupingId:0,

            customProductForm:{
                goods_name: "",
                image: [],
                unit: "",
                description: "",
                cost_price: "",
                is_sale: 1,
                is_lease: 1,
                sale_price: "0.00",
                lease_price: "0.00",
                can_in_out_stock: 0,
                part:[
                    {
                        part_name: "",
                        num: 1,
                        is_show: 1,
                        is_add: 1,
                        num_edit: 1,
                        goods_list:[]
                    }
                ]
            },
            customProductFormRules:{
                goods_name:[{ required: true, message: '请输入产品名称', trigger: 'blue'}],
            },
            regionAddVisible:false,
            selectedData:[],

            stock_product:[], //库存产品已选
            basic_product:[], //行业标准产品已选
            custom_product:[], //自定义产品
            bundle_product:[], //组合产品
            category_id: 0,//上架到的分组
            is_online: 1, //是否上架

            category_name:'',
            regionInfo:null,
            groupingSwitchVisible:false,

            goodsInfo:null,
            goodsType:'',
            goodsKey:0,
            ordinaryEditVisible:false,//库存产品编辑 自定义产品编辑
            standardEditVisible:false, //标准产品编辑
            combinationEditVisible:false, //组合产品编辑
        };
    },
    mixins: [pagination],
    computed: {

    },
    created() {
        if(this.$route.query.category_id && this.$route.query.category_name){
            this.category_id = this.$route.query.category_id
            this.category_name = this.$route.query.category_name
        }
        this.tableHeight = getTableHeight(270)
        this.getTableData()
    },
    mounted() {

    },
    methods: {
        handleClickReturn(){
            this.$router.go(-1)
        },
        // 切换分组
        groupingSwitchSuccess(data){
            this.category_id = data.id
            this.category_name = data.name
        },
        handleClickTab(item){
          this.tabActive = item.value
          this.tableData = []
          this.basicTableData = []
          this.keyword = ''
          if(item.value == 2){
              this.groupingId = 0
              this.getCloudCateList()
          }
          this.handleClickSearch()
        },
        handleBlurPrice(field){
            let price = this.customProductForm[field].replace(',', '')
            price = this.customProductForm[field].replace(/[^\d.]/g, '')
            if(price < 0){
                this.customProductForm[field] = 0
            }
            price = Number(price).toFixed(2)
            this.customProductForm[field] =  Number(price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        },
        // 点击分组
        handleClickGroupingItem(item){
            this.groupingId = item.id
            this.handleClickSearch()
        },
        // 添加部位
        handleClickAddRegion(){
            let json =  {
                part_name: "",
                num: 1,
                is_show: 1,
                is_add: 1,
                num_edit: 1,
                goods_list:[]
            }
            this.customProductForm.part.push(json)
        },
        // 切换产品、添加产品
        handleClickChangeProduct(item,type){
            if(type == 'switch'){
                this.regionAddVisible = true
            }else if(type == 'add'){
                this.regionAddVisible = true
            }
            this.regionInfo = item
            this.selectedData = item.goods_list
        },
        // 选择产品后回调
        regionAddSuccess(data){
            if(data[0].type == 'basic'){
                data[0].skus.forEach((list)=>{
                    this.$set(list, 'status', true)
                })
            }
            this.$set(this.regionInfo,'type',data[0].type)
            this.$set(this.regionInfo,'goods_list',data)
        },
        // 选择库存产品
        handleSelectionChange(val){
            // this.stock_product = val;
            val.forEach(item => {
                if (!this.stock_product.some(d => d.product_name === item.product_name)) {
                    this.stock_product.push(item);
                }
            });
            this.stock_product = this.stock_product.filter(d => val.some(item => item.product_name === d.product_name));
        },
        // 库存产品禁用选择
        disableSelection(row){
            return !row.is_online
        },
        // 选择标准库产品
        handleChangeStandardItem(item){
            this.$nextTick(()=>{
                if(item.checked){
                    item.skus.forEach((list)=>{
                        if(!list.is_online){
                            this.$set(list, 'checked', true)
                        }
                    })
                    this.get_basic_product('add',item)
                }else{
                    item.skus.forEach((list)=>{
                        if(!list.is_online){
                            this.$set(list, 'checked', false)
                        }
                    })
                    this.get_basic_product('del',item)
                }
            })
        },
        handleChangeStandardList(item,list){
            this.$nextTick(() => {
                if(item.skus){
                    if(item.skus.filter(find => !find.is_online).length == item.skus.filter(find => find.checked).length){
                        this.$set(item, 'checked', true)
                    }else{
                        this.$set(item, 'checked', false)
                    }
                }
                if(list.checked){
                    this.get_basic_product('add',item)
                }else{
                    this.get_basic_product('del',item)
                }
            })
        },

        // 获取行业标准产品
        get_basic_product(type,item){
            let data = JSON.parse(JSON.stringify(item))
            if(type == 'add'){
                let info = this.basic_product.find(find => find.id == data.id)
                if(info){
                    info.skus = data.skus.filter(find => find.checked)
                    info.image = info.skus.map(map => map.image).filter(image => image !== null && image !== undefined && image !== '');
                }else{
                    data.skus = data.skus.filter(find => find.checked)
                    data.image = data.skus.map(map => map.image).filter(image => image !== null && image !== undefined && image !== '');
                    this.basic_product.push(data)
                }
            }else if(type == 'del'){
                let info = this.basic_product.find(find => find.id == data.id)
                if(info){
                    info.skus = data.skus.filter(find => find.checked)
                    info.image = info.skus.map(map => map.image).filter(image => image !== null && image !== undefined && image !== '');
                    if(info.skus.length == 0){
                        this.basic_product.splice(this.basic_product.findIndex(find => find.id == data.id),1)
                    }
                }
            }
        },
        // 保存自定义产品 / 组合产品
        handleClickSave(type){
           if(type == 'custom_product'){
               this.$refs.customProductForm.validate(valid => {
                   if (valid) {
                       let json = {
                           goods_name: this.customProductForm.goods_name,
                           image: this.customProductForm.image,
                           unit: this.customProductForm.unit,
                           description: this.customProductForm.description,
                           cost_price: this.customProductForm.cost_price,
                           is_sale: this.customProductForm.is_sale,
                           is_lease: this.customProductForm.is_lease,
                           sale_price: this.customProductForm.sale_price,
                           lease_price: this.customProductForm.lease_price,
                           can_in_out_stock: this.customProductForm.can_in_out_stock,
                       }
                       this.custom_product.push(json)
                       this.customProductForm = JSON.parse(JSON.stringify(this.$options.data().customProductForm))
                   }
               })
           }else if(type == 'bundle_product'){
               this.$refs.bundleProductForm.validate(valid => {
                   if (valid) {
                        let json = {
                           goods_name: this.customProductForm.goods_name,
                           image: this.customProductForm.image,
                           unit: this.customProductForm.unit,
                           description: this.customProductForm.description,
                           is_sale: this.customProductForm.is_sale,
                           is_lease: this.customProductForm.is_lease,
                           part: this.customProductForm.part,
                       }
                       if(json.part.find(find => find.part_name == '')){
                           this.$message.error('请填写部位名称')
                           return false
                       }
                       if(json.part.find(find => find.goods_list.length == 0)){
                           this.$message.error('请添加部位中的产品')
                           return false
                       }
                       this.bundle_product.push(json)
                       this.customProductForm = JSON.parse(JSON.stringify(this.$options.data().customProductForm))
                   }
               })

           }
        },
        // 编辑已选产品
        handleClickGoodsEdit(item,key,type){
            this.goodsInfo = item
            this.goodsType = type
            this.goodsKey = key
            if(type == 'custom' || type == 'stock'){
                this.ordinaryEditVisible = true //库存产品编辑 自定义产品编辑
            }else if(type == 'basic'){
                this.standardEditVisible = true //标准产品编辑
            }else{
                this.combinationEditVisible = true //组合产品编辑
            }
        },
        // 编辑已选之后的回调
        goodsEditSuccess(data){
            if(this.goodsType == 'custom'){
                this.$set(this.custom_product,this.goodsKey,data)
            }else if(this.goodsType == 'stock'){
                this.$set(this.stock_product,this.goodsKey,data)
            }else if(this.goodsType == 'basic'){
                this.$set(this.basic_product,this.goodsKey,data)
                // 行业标准产品左侧选中状态更改
                this.basicTableData.forEach(item => {
                    if(data.id == item.id){
                        item.skus.forEach(skus => {
                            this.$set(skus,'checked',false)
                            if(data.skus.find(find => find.sku_id == skus.sku_id)){
                                this.$set(skus,'checked',true)
                            }
                        })
                    }
                })
            }else if(this.goodsType == 'bundle'){
                this.$set(this.bundle_product,this.goodsKey,data)
            }
        },

        // 删除库存产品
        handleClickDelProduct(type,key,item){
            if(type == 'stock'){
                this.stock_product.splice(key,1)
                this.$refs.stock_product_table.toggleRowSelection(item,false)
            }else if(type == 'basic'){
                this.basicTableData.forEach(find => {
                   if(item.id == find.id){
                       this.$set(find,'checked',false)
                       find.skus.forEach(skus => {
                           this.$set(skus,'checked',false)
                       })
                   }
                })
                this.basic_product.splice(key,1)
            }
        },
        handleClickConfirm(){
          let stock_product = this.stock_product.map((map)=>{
              return {
                  goods_name : map.goods_name,
                  image: map.image,
                  unit: map.unit,
                  description: map.description,
                  product_name: map.product_name,
                  sku_id: map.sku_id,
                  cost_price: map.cost_price ? map.cost_price.replace(/,+/g, '') : 0,
                  is_sale: map.is_sale,
                  is_lease: map.is_lease,
                  sale_price: map.sale_price ? map.sale_price.replace(/,+/g, '') : 0,
                  lease_price: map.lease_price ? map.lease_price.replace(/,+/g, '') : 0,
              }
          })
          let basic_product = this.basic_product.map((map)=>{
              return {
                  id: map.id,
                  product_name : map.name,
                  image: map.image,
                  unit: map.unit,
                  brand_id: map.brand_id,
                  skus:map.skus.map((childMap)=>{
                      return {
                          sku_id : childMap.sku_id,
                          sku_key : childMap.sku_key,
                          goods_name : childMap.goods_name,
                          product_name : childMap.name,
                          cost_price : childMap.cost_price ? childMap.cost_price.replace(/,+/g, '') : 0,
                          is_sale : childMap.is_sale,
                          is_lease : childMap.is_lease,
                          sale_price : childMap.sale_price ? childMap.sale_price.replace(/,+/g, '') : 0,
                          lease_price :childMap.lease_price ? childMap.lease_price.replace(/,+/g, '') : 0,
                      }
                  })
              }
          })
          let custom_product = this.custom_product.map((map)=>{
              return {
                  goods_name : map.goods_name,
                  image: map.image,
                  unit: map.unit,
                  description: map.description,
                  cost_price: map.cost_price ? map.cost_price.replace(/,+/g, '') : 0,
                  is_sale: map.is_sale,
                  is_lease: map.is_lease,
                  sale_price: map.sale_price ? map.sale_price.replace(/,+/g, '') : 0,
                  lease_price: map.lease_price ? map.lease_price.replace(/,+/g, '') : 0,
                  can_in_out_stock: map.can_in_out_stock,
              }
          })
          let bundle_product = this.bundle_product.map((map)=>{
              return {
                  goods_name : map.goods_name,
                  image: map.image,
                  unit: '',
                  description: map.description,
                  is_sale: map.is_sale,
                  is_lease: map.is_lease,
                  part: map.part.map((childMap)=>{
                      return {
                          part_name: childMap.part_name,
                          num: childMap.num,
                          is_show: childMap.is_show,
                          is_add: childMap.is_add,
                          num_edit: childMap.num_edit,
                          type:childMap.type,
                          goods_list: childMap.goods_list.map((goodsMap)=>{
                              return {
                                  goods_id : goodsMap.goods_id,
                                  type : goodsMap.type,
                                  goods_name : goodsMap.goods_name,
                                  brand_name : goodsMap.brand_name,
                                  skus: goodsMap.type == 'basic' ? goodsMap.skus.filter(find => find.status == 1) : goodsMap.skus
                              }
                          })
                      }
                  })
              }
          })
          if(stock_product.length == 0 && basic_product.length == 0 && custom_product.length == 0 && bundle_product.length == 0){
              return  this.$message.error('请至少选择上架一个产品')
          }
          if(!this.category_id){
              return  this.$message.error('请选择上架到的分组')
          }
          let postData = {
              product_list:{
                  stock_product: stock_product,
                  basic_product: basic_product,
                  custom_product: custom_product,
                  bundle_product: bundle_product,
              },
              category_id: this.category_id,
              is_online: this.is_online,
          }

            this.btnDisabled = true
            GoodsPutProductOnline(postData).then(res => {
                if (res.code === 200) {
                   this.$message({
                       type: 'success',
                       message:'操作成功',
                       duration: 1500,
                       onClose: () => {
                           removeTag(this.$route)
                           this.$router.go(-1);
                           this.btnDisabled = false
                       }
                   })
                }else{
                    this.btnDisabled = false
                }

            })

        },
        // 上传产品图片
        handleClickUploadImg(e,field) {
            const files = Array.from(e.target.files)
            if (field.length === 5) return this.$message.error('最多只能上传5张图片')
            if(files.length + field.length > 5) return this.$message.error('最多只能上传5张图片')
            files.forEach(file => {
                if(file.type != 'image/png' && file.type != 'image/jpeg'){
                    this.$message.error(`${file.name}文件格式不正确`)
                    return false
                }
                uploadImg(file, 2).then(res => {
                    if (res.file_path) {
                        field.push(res.file_path)
                        e.target.value = ''
                    }
                }).catch(error => {
                    e.target.value = ''
                })

            })
        },
        // 回车搜索
        handleEnterSearch(){
            this.$nextTick(()=>{
                if(this.$refs.search_input_ref1){
                    this.$refs.search_input_ref1.blur()
                }
                if(this.$refs.search_input_ref2){
                    this.$refs.search_input_ref2.blur()
                }
            })
        },
        // 搜索
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.tableData = []
            this.basicTableData = []
            this.getTableData()
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        onLoadList(){
            if(this.pagination.total == this.basicTableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.keyword
            }
            if(this.tabActive == 1){
                this.loading = true
                GoodsStockProductList(postData).then(res => {
                    if (res.code === 200) {
                        let {list,total} = res.data
                        list.forEach((item)=>{
                            this.$set(item,'goods_name','')
                            this.$set(item,'image',[])
                            this.$set(item,'unit','')
                            this.$set(item,'description','')
                            this.$set(item,'cost_price','')
                            this.$set(item,'is_sale',1)
                            this.$set(item,'is_lease',0)
                            this.$set(item,'sale_price','0.00')
                            this.$set(item,'lease_price','0.00')
                        })
                        this.tableData = list
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            }else if(this.tabActive == 2){
                postData.category_id = this.groupingId
                this.loading = true
                GoodsUpProductList(postData).then(res => {
                    if (res.code === 200) {
                        let {list,total} = res.data
                        list.forEach((item)=>{
                            this.$set(item,'is_down_up',true)
                            this.$set(item,'product_name',item.name)
                            this.$set(item,'description','')
                            this.$set(item,'image',[])
                            if(item.skus){
                                item.skus.forEach((skusItem)=>{
                                    this.$set(skusItem,'goods_name','')
                                    this.$set(skusItem,'product_name',skusItem.name)
                                    this.$set(skusItem,'cost_price','')
                                    this.$set(skusItem,'is_sale',1)
                                    this.$set(skusItem,'is_lease',1)
                                    this.$set(skusItem,'sale_price','0.00')
                                    this.$set(skusItem,'lease_price','0.00')
                                })
                            }
                            let info = this.basic_product.find(find => find.id == item.id) //是否是已选的
                            if(info){
                                let online_length = item.skus.filter(filter => filter.is_online == false).length //还可以选择的数量
                                if(info.skus.length == online_length){
                                    this.$set(item,'checked',true)
                                }
                                item.skus.forEach((skusItem)=>{
                                    if(info.skus.find(find => find.sku_id == skusItem.sku_id)){
                                        this.$set(skusItem,'checked',true)
                                    }
                                })
                            }
                        })
                        this.basicTableData = this.basicTableData.concat(list)
                        this.pagination.total = total
                        this.pagination.pageNum++;
                    }
                    this.loading = false
                })
            }

        },
        // 获取产品分组
        getCloudCateList(){
            cloudCateList({keyword:this.keyword}).then(res => {
                if (res.code === 200) {
                    this.groupingList = res.data
                    this.$nextTick(() => {
                        this.$refs.cateGoryTreeRef.setCurrentKey(this.groupingId)
                    })
                }
            })

        },

    },
}
</script>

<style  lang="scss" scoped>
@import "@/styles/product_shelves.scss";

</style>